<template>
  <b-container class="slider-container">
    <swiper class="swiper-navigations" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in swiperData" :key="index">
        <b-img
          :src="item.image_url"
          class="swiper-image"
          :style="`cursor: ${item.meta && item.meta.url ? 'pointer' : 'default'}`"
          @click="handleClickAds(item)"
        />
      </swiper-slide>

      <!-- Navigation -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>

      <!-- Pagination -->
      <div class="swiper-pagination"></div>

    </swiper>
  </b-container>
</template>

<script>
import { BContainer, BImg } from 'bootstrap-vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import { checkPermission, successNotification, errorNotification } from '@/auth/utils'

import 'swiper/css/swiper.css'

export default {
  title() {
    return "Welcome 🚀";
  },
  components: {
    BContainer,
    BImg,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      swiperData: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      isLoading: false,

      swiperOptions: {
        spaceBetween: 30,
        effect: 'fade',
        autoHeight: false,

        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
  // eslint-disable-next-line consistent-return
  created() {
    const { phone_verified_at } = JSON.parse(localStorage.getItem("userData"));
    // eslint-disable-next-line camelcase
    if (!phone_verified_at) {
      return this.$router.push("/otp");
    }
  },
  mounted() {
    this.getAds()
  },
  methods: {
    async handleClickAds(item) {
      try {
        const ipResponse = await fetch(
          'https://api.ipify.org?format=json',
        )

        const { ip } = await ipResponse.json();

        await this.$http.post('/track-click',
          {
            user_id: this.userData.id,
            image_id: item.id,
            user_ip: ip,
          })

        if (item.meta?.url) {
          window.open(item.meta.url, '_blank')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getAds() {
      try {
        let response = await this.$http.get('/sliders')
        this.swiperData = response.data.data
      } catch (err) {
        console.error(err);  // eslint-disable-line no-console
      } finally {
        this.isLoading = false;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.slider-container {
  width: 100%;
  padding: 1rem;
}

.swiper-navigations {
  width: 100%;
  height: clamp(220px, 45vw, 600px);
  background: #EFF3F7;
  border-radius: 12px;
  overflow: hidden;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #EFF3F7;
}

.swiper-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Tablet */
@media (max-width: 992px) {
  .swiper-navigations {
    height: clamp(220px, 50vw, 450px);
  }
}

/* Mobile */
@media (max-width: 768px) {
  .slider-container {
    padding: 0.5rem;
  }

  .swiper-navigations {
    height: clamp(180px, 55vw, 320px);
    border-radius: 8px;
  }

  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.8);
  }
}
</style>
